(() => {
  const FILTERS = [
    { key: 'origin', label: 'Menşei' },
    { key: 'altitude', label: 'Rakım' },
    { key: 'process', label: 'İşleme yöntemi' },
    { key: 'variety', label: 'Varyete' },
    { key: 'brew', label: 'Demleme yöntemi' },
    { key: 'roast', label: 'Kavrum' },
    { key: 'profile', label: 'Tat profili' },
    { key: 'notes', label: 'Tadım notları' },
  ];
  const QUERY_PREFIX = 'kahve_';
  const state = new Map(FILTERS.map(({ key }) => [key, new Set()]));
  let currentGroups = [];
  let initializedFromUrl = false;
  let scheduled = false;

  const normalize = (value) => String(value ?? '').normalize('NFC').trim().toLocaleLowerCase('tr-TR');

  const canonicalLabel = (key, value) => {
    const label = String(value ?? '').normalize('NFC').trim();
    const normalized = normalize(label);

    if (key === 'profile') {
      if (normalized.includes('çikolata') && (normalized.includes('meyve') || normalized.includes('meyvemsi'))) {
        return 'Meyve + çikolata';
      }
      if (normalized === 'çikolata' || normalized === 'çikolata notalı') return 'Çikolata notalı';
      if (normalized === 'meyve' || normalized === 'meyvemsi' || normalized === 'meyve notalı') return 'Meyvemsi';
    }

    return label;
  };

  const parseValues = (raw) => {
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      const values = Array.isArray(parsed) ? parsed : [parsed];
      return values.map((value) => String(value ?? '').normalize('NFC').trim()).filter(Boolean);
    } catch (_error) {
      return [];
    }
  };

  const getCards = () => Array.from(document.querySelectorAll('[data-coffee-filter-card]'));

  const cardValues = (card, key) =>
    parseValues(card.dataset[`coffee${key[0].toUpperCase()}${key.slice(1)}`]).map((value) => canonicalLabel(key, value));

  const readUrlState = () => {
    const params = new URLSearchParams(window.location.search);
    FILTERS.forEach(({ key }) => {
      const selected = state.get(key);
      selected.clear();
      params.getAll(`${QUERY_PREFIX}${key}`).map(normalize).filter(Boolean).forEach((value) => selected.add(value));
    });
  };

  const writeUrlState = (groups) => {
    const url = new URL(window.location.href);
    FILTERS.forEach(({ key }) => url.searchParams.delete(`${QUERY_PREFIX}${key}`));

    groups.forEach(({ key, options }) => {
      const selected = state.get(key);
      options.forEach(({ normalized, label }) => {
        if (selected.has(normalized)) url.searchParams.append(`${QUERY_PREFIX}${key}`, label);
      });
    });

    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const collectGroups = (cards) =>
    FILTERS.map(({ key, label }) => {
      const values = new Map();

      cards.forEach((card) => {
        cardValues(card, key).forEach((value) => {
          const normalized = normalize(value);
          if (!normalized) return;
          const entry = values.get(normalized) || { label: value, normalized, count: 0 };
          entry.count += 1;
          values.set(normalized, entry);
        });
      });

      return {
        key,
        label,
        options: Array.from(values.values()).sort((a, b) => a.label.localeCompare(b.label, 'tr')),
      };
    }).filter(({ options }) => options.length >= 2);

  const rememberGroups = (discoveredGroups) => {
    if (!currentGroups.length) {
      currentGroups = discoveredGroups;
      return currentGroups;
    }

    discoveredGroups.forEach((discovered) => {
      const existing = currentGroups.find(({ key }) => key === discovered.key);
      if (!existing) {
        currentGroups.push(discovered);
        return;
      }

      const known = new Set(existing.options.map(({ normalized }) => normalized));
      discovered.options.forEach((option) => {
        if (!known.has(option.normalized)) existing.options.push(option);
      });
      existing.options.sort((a, b) => a.label.localeCompare(b.label, 'tr'));
    });

    return currentGroups;
  };

  const pruneNativeFacets = () => {
    document
      .querySelectorAll('#main-collection-filters .facets__disclosure-vertical, #main-collection-filters .mobile-facets__details')
      .forEach((details) => {
        const inputs = Array.from(details.querySelectorAll("input[type='checkbox']"));
        if (!inputs.length) return;
        const active = inputs.some((input) => input.checked);
        const meaningful = inputs.filter((input) => !input.disabled);
        details.hidden = !active && meaningful.length <= 1;
      });
  };

  const createFilterGroup = (group, mode) => {
    const details = document.createElement('details');
    details.className = 'dabov-coffee-filter';
    details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'dabov-coffee-filter__summary';

    const heading = document.createElement('span');
    heading.textContent = group.label;
    summary.append(heading);

    const caret = document.createElement('span');
    caret.className = 'dabov-coffee-filter__caret';
    caret.setAttribute('aria-hidden', 'true');
    summary.append(caret);
    details.append(summary);

    const list = document.createElement('ul');
    list.className = 'dabov-coffee-filter__options';
    list.setAttribute('role', 'list');

    group.options.forEach(({ label, normalized, count }, index) => {
      const item = document.createElement('li');
      const inputId = `CoffeeFilter-${mode}-${group.key}-${index}`;
      const labelElement = document.createElement('label');
      labelElement.className = 'dabov-coffee-filter__option';
      labelElement.htmlFor = inputId;

      const input = document.createElement('input');
      input.type = 'checkbox';
      input.id = inputId;
      input.value = normalized;
      input.dataset.coffeeFilterInput = group.key;
      input.checked = state.get(group.key).has(normalized);

      const checkbox = document.createElement('span');
      checkbox.className = 'dabov-coffee-filter__checkbox';
      checkbox.setAttribute('aria-hidden', 'true');

      const text = document.createElement('span');
      text.className = 'dabov-coffee-filter__option-label';
      text.textContent = label;

      const optionCount = document.createElement('span');
      optionCount.className = 'dabov-coffee-filter__option-count';
      optionCount.textContent = String(count);
      optionCount.setAttribute('aria-label', `${count} ürün`);

      labelElement.append(input, checkbox, text, optionCount);
      item.append(labelElement);
      list.append(item);
    });

    details.append(list);
    return details;
  };

  const syncControls = () => {
    document.querySelectorAll('[data-coffee-filter-input]').forEach((input) => {
      input.checked = state.get(input.dataset.coffeeFilterInput)?.has(input.value) || false;
    });

    const activeCount = Array.from(state.values()).reduce((total, values) => total + values.size, 0);
    document.querySelectorAll('[data-coffee-filter-active-count]').forEach((node) => {
      node.hidden = activeCount === 0;
      node.textContent = activeCount ? String(activeCount) : '';
      node.setAttribute('aria-label', `${activeCount} etkin filtre`);
    });

    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach((form) => {
      form.querySelectorAll('[data-coffee-filter-native-param]').forEach((input) => input.remove());

      currentGroups.forEach(({ key, options }) => {
        const selected = state.get(key);
        options.forEach(({ label, normalized }) => {
          if (!selected.has(normalized)) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `${QUERY_PREFIX}${key}`;
          input.value = label;
          input.dataset.coffeeFilterNativeParam = '';
          form.append(input);
        });
      });
    });
  };

  const applyFilters = () => {
    const cards = getCards();
    let visibleCount = 0;
    const hasActiveCustomFilter = Array.from(state.values()).some((values) => values.size > 0);

    cards.forEach((card) => {
      const matches = FILTERS.every(({ key }) => {
        const selected = state.get(key);
        if (!selected?.size) return true;
        return cardValues(card, key).some((value) => selected.has(normalize(value)));
      });

      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    document.querySelectorAll('[data-coffee-filter-result-count]').forEach((node) => {
      node.textContent = `${visibleCount} kahve gösteriliyor`;
    });

    document.querySelectorAll('[data-coffee-filter-empty]').forEach((node) => {
      node.hidden = !hasActiveCustomFilter || visibleCount !== 0;
    });

    syncControls();
  };

  const render = () => {
    const cards = getCards();
    const roots = Array.from(document.querySelectorAll('[data-coffee-filter-root]'));
    if (!roots.length) return;

    if (!initializedFromUrl) {
      readUrlState();
      initializedFromUrl = true;
    }

    const groups = rememberGroups(collectGroups(cards));
    pruneNativeFacets();

    roots.forEach((root) => {
      const mode = root.dataset.coffeeFilterMode || 'desktop';
      root.replaceChildren();

      const header = document.createElement('div');
      header.className = 'dabov-coffee-filters__header';

      const title = document.createElement('h2');
      title.className = 'dabov-coffee-filters__title';
      title.textContent = 'Kahveni filtrele';

      const clearButton = document.createElement('button');
      clearButton.className = 'dabov-coffee-filters__clear';
      clearButton.type = 'button';
      clearButton.textContent = 'Temizle';
      clearButton.dataset.coffeeFilterClear = '';

      header.append(title, clearButton);
      root.append(header);
      groups.forEach((group) => root.append(createFilterGroup(group, mode)));

      const status = document.createElement('p');
      status.className = 'dabov-coffee-filters__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.dataset.coffeeFilterResultCount = '';
      root.append(status);

      root.hidden = groups.length === 0;
    });

    const drawer = document.querySelector('[data-coffee-filter-drawer]');
    if (drawer) drawer.hidden = groups.length === 0;

    let empty = document.querySelector('[data-coffee-filter-empty]');
    const grid = document.querySelector('#product-grid');
    if (!empty && grid) {
      empty = document.createElement('div');
      empty.className = 'dabov-coffee-filter-empty';
      empty.dataset.coffeeFilterEmpty = '';
      empty.hidden = true;
      empty.innerHTML = '<h2>Bu seçimlerle eşleşen kahve bulunamadı.</h2><p>Bir veya daha fazla filtreyi temizleyerek yeniden deneyin.</p>';
      grid.insertAdjacentElement('afterend', empty);
    }

    applyFilters();

    document.querySelectorAll('[data-coffee-filter-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const selected = state.get(input.dataset.coffeeFilterInput);
        if (input.checked) selected.add(input.value);
        else selected.delete(input.value);
        writeUrlState(groups);
        applyFilters();
      });
    });

    document.querySelectorAll('[data-coffee-filter-clear]').forEach((button) => {
      button.addEventListener('click', () => {
        state.forEach((values) => values.clear());
        writeUrlState(groups);
        applyFilters();
      });
    });
  };

  const scheduleRender = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      render();
    });
  };

  document.addEventListener('DOMContentLoaded', scheduleRender, { once: true });
  document.addEventListener('shopify:section:load', scheduleRender);
  window.addEventListener('popstate', () => {
    readUrlState();
    scheduleRender();
  });

  new MutationObserver((mutations) => {
    if (
      mutations.some(({ target, addedNodes }) => {
        const targetIsGrid =
          target.nodeType === 1 && (target.matches?.('#ProductGridContainer') || target.closest?.('#ProductGridContainer'));
        const productCardsAdded = Array.from(addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('[data-coffee-filter-card], #product-grid') ||
              node.querySelector?.('[data-coffee-filter-card], #product-grid')),
        );
        return targetIsGrid || productCardsAdded;
      })
    ) {
      scheduleRender();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
